import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { toast } from "sonner";

export default function Login() {
    const { login } = useAuth();
    const nav = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [err, setErr] = useState("");
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setErr("");
        setLoading(true);
        const res = await login(email.trim().toLowerCase(), password);
        setLoading(false);
        if (res.ok) {
            toast.success("Connecté");
            nav("/dashboard");
        } else setErr(res.error);
    };

    return (
        <div className="min-h-[78vh] flex items-center justify-center px-6 py-16">
            <div className="w-full max-w-md">
                <div className="text-[11px] uppercase tracking-[0.25em] text-orange-500 font-bold mb-2">
                    Connexion
                </div>
                <h1 className="font-display text-5xl uppercase tracking-tight mb-8">
                    Bon retour parmi nous
                </h1>
                <form onSubmit={submit} className="card-tu space-y-5">
                    <div>
                        <label className="label-tu">Email</label>
                        <input
                            data-testid="login-email"
                            type="email"
                            inputMode="email"
                            autoCapitalize="none"
                            autoCorrect="off"
                            spellCheck="false"
                            autoComplete="email"
                            required
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className="input-tu"
                        />
                    </div>
                    <div>
                        <label className="label-tu">Mot de passe</label>
                        <input
                            data-testid="login-password"
                            type="password"
                            required
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className="input-tu"
                        />
                    </div>
                    {err && (
                        <div className="text-sm text-red-500 border border-red-900/50 bg-red-950/30 p-3">
                            {err}
                        </div>
                    )}
                    <button
                        data-testid="login-submit"
                        disabled={loading}
                        className="btn-primary w-full"
                    >
                        {loading ? "Connexion…" : "Se connecter"}
                    </button>
                    <div className="text-right -mt-2">
                        <Link
                            to="/forgot-password"
                            data-testid="goto-forgot"
                            className="text-xs uppercase tracking-widest text-zinc-400 hover:text-orange-500"
                        >
                            Mot de passe oublié ?
                        </Link>
                    </div>
                </form>
                <p className="mt-6 text-center text-sm text-zinc-400">
                    Pas encore de compte ?{" "}
                    <Link to="/register" data-testid="goto-register" className="text-orange-500 font-bold uppercase tracking-widest text-xs">
                        Inscription
                    </Link>
                </p>
            </div>
        </div>
    );
}
